import {
    AfterViewChecked,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    Output,
    Renderer2,
    ViewEncapsulation,
} from '@angular/core';
import { NgClass, NgIf } from '@angular/common';

import { PaginatorModule } from 'primeng/paginator';
import { TranslateModule } from '@ngx-translate/core';

import { common } from '@qwyk/models';

import { PageRequest } from './page-request';

@Component({
    standalone: true,
    imports: [NgIf, NgClass, TranslateModule, PaginatorModule],
    selector: 'qwyk-pagination',
    templateUrl: './pagination.component.html',
    styleUrls: ['./pagination.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class PaginationComponent implements AfterViewChecked {
    @Input() pagination: common.PaginationMeta;
    @Input() loading: boolean;
    @Input() onlyPrevAndNextMode = false;
    @Input() resource: string;
    @Input() small = false;
    @Input() showPageLinks = true;
    @Input() showFirstLastIcon = true;
    @Input() showCurrentPageReport = true;
    @Input() showJumpToPageDropdown = true;
    @Input() pageSizeOptions: number[] = [10, 25, 50];
    @Input() wrapperClass = '';
    @Input() simplifiedPagination = false;
    @Input() hasNextPage = false;
    @Output() pageChanged: EventEmitter<PageRequest> =
        new EventEmitter<PageRequest>();

    constructor(
        private readonly el: ElementRef,
        private readonly renderer: Renderer2
    ) {}

    get effectiveTotalRecords(): number {
        if (this.pagination?.total != null) {
            return this.pagination.total;
        }
        return this.hasNextPage
            ? this.pagination.to + 1
            : this.pagination.to;
    }

    ngAfterViewChecked(): void {
        const pagesContainer = this.el.nativeElement.querySelector('.p-paginator-pages');
        if (!pagesContainer) return;

        const existing = pagesContainer.querySelector('.p-paginator-ellipsis');

        if (this.hasNextPage && !existing) {
            const btn = this.renderer.createElement('button');
            this.renderer.addClass(btn, 'p-paginator-page');
            this.renderer.addClass(btn, 'p-paginator-element');
            this.renderer.addClass(btn, 'p-link');
            this.renderer.addClass(btn, 'p-paginator-ellipsis');
            this.renderer.setAttribute(btn, 'disabled', '');
            this.renderer.setProperty(btn, 'textContent', '...');
            this.renderer.appendChild(pagesContainer, btn);
        } else if (!this.hasNextPage && existing) {
            this.renderer.removeChild(pagesContainer, existing);
        }
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onPageChange($event: any) {
        const pageRequest: PageRequest = {
            page: Number($event.page) + 1,
            page_size: Number($event.rows),
        };
        this.pageChanged.emit(pageRequest);
    }
}
